import React, { useEffect, useRef } from "react";
import Rellax from "rellax";
import { cn } from "../lib/helpers";
import { responsiveTitle1, bodyTextBlock } from "./typography.module.css";
import { useMediaQuery } from "react-responsive";
import { mediaMaxSmall } from "../lib/mediaQueries";

import PortableText from "./portableText";

import styles from "./our-work.module.css";

function OurWork(props) {
  const { title, closingCopy, children } = props;
  const isMobile = useMediaQuery(mediaMaxSmall);

  const contentRef = useRef(null);

  useEffect(() => {
    if (!isMobile) {
      const rellaxOptions = {
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false,
      };
      const contentRellax = new Rellax(contentRef.current, {
        ...rellaxOptions,
        speed: 0.5,
      });
      const rellaxInstances = [contentRellax];
      return () => {
        //reset for page changes
        rellaxInstances.forEach((instance) => {
          instance.destroy();
        });
      };
    }
  });

  return (
    <div className={cn(styles.root)}>
      <div className={styles.content} ref={contentRef}>
        {title && <h2 className={cn(responsiveTitle1, styles.title)}>{title}</h2>}

        {children}

        {closingCopy && (
          <div className={cn(styles.bottomCopy, bodyTextBlock)}>
            <div className={styles.bottomCopyInner}>
              <PortableText blocks={closingCopy} />
              <div className={styles.signature}>Love, Capacity &#60;3</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

OurWork.defaultProps = {
  title: "",
  nodes: [],
  browseMoreHref: "",
};

export default OurWork;
